import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  selectedTab,
  selectedPin,
  reviewAdded,
} from '../actions/dive-guide-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
} from '../actions/main-actions'
import {
  currencyDirective,
  hideMobileAppPromotion,
  convertDjangoRenderedPrice,
  diveGuidesHeaderFooter,
  showModalOnClick,
  collapseItems,
  breadcrumbsToggle,
} from '../directives'
import ErrorHandler from '../components/ErrorHandler'

// import * as fx from '../libs/money'
import { getLanguage, getTranslations } from 'utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'
import HeroLightbox from '../components/liveaboard/HeroLightbox'
import BookDiving from '../components/dive-guides/book-diving/BookDiving'
import SliderDg from '../components/dive-guides/SliderDg'
import DiveSiteMap from '../components/dive-guides/map/DiveSiteMap'
import HeroGalleryMobile from '../components/helpers/HeroGalleryMobile'
import PadiSearch from '../components/dive-guides/PadiSearch'
import { adventureTabsArray } from '../components/dive-guides/book-diving/tabs'
import { DiveSiteHeader } from '../components/dive-guides/DiveSiteHeader'
import Reviews from '../components/dive-guides/reviews/Reviews'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    selectedPin,
    selectedTab,
    selectedCurrency,
    reviewAdded,
  }),
)

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }

  renderElement('padi-search', PadiSearch)
  renderElement('padi-search-mobile', PadiSearch)
  renderElement('dive-site-header', DiveSiteHeader, {
    location: window.locationData && window.locationData.locationTitle,
    diveSite: window.diveSiteTitle,
  })
  renderElement('hero-lightbox', HeroLightbox, {
    photos: window.photos,
    videos: window.videos,
  })

  if(window.innerWidth < 768) {
    renderElement('collage-photos', HeroGalleryMobile, {
      photos: window.photos,
      videos: window.videos,
    })
  }

  renderElement('dive-site-map', DiveSiteMap, {
    pins: window.diveCenterPoints,
    dsPoint: window.dsPoint,
    style: {
      width: '100%',
      height: '100%',
    },
    countryCode: window.countryCode,
  })

  renderElement('book-adventure-diving', BookDiving, {
    location: window.locationData,
    tabs: adventureTabsArray,
    isWidget: window.isWidget,
    isDiveSite: true,
  })

  renderElement('best-dive-sites', SliderDg, {
    data: window.topSites,
    area: window.locationData,
    view: 3,
    name: 'top-sites',
    regionIdentifier: 'dive-sites-nearby',
  })

  if(window.locationData) {
    renderElement('reviews-list', Reviews, {
      diveSite: {
        title: window.diveSiteTitle,
        id: window.locationData.diveSiteId,
      },
    })
  }

  hideMobileAppPromotion()
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  collapseItems()
  convertDjangoRenderedPrice(renderElement)
  diveGuidesHeaderFooter()
  showModalOnClick(renderElement)
  breadcrumbsToggle()
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
